<template>
  <div id="app">
    <app-header></app-header>
    <router-view class="main__component"></router-view>
  </div>
</template>

<script>
import Header from './components/theHeader'

export default {
  name: 'app',
  components: {
    'app-header': Header
  },
  computed: {
  },
}
</script>

<style lang="scss">
// Clearing all base config for styling
* ,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

html{
  // This defines what 1 REM is (10px ofr standard font size of 16px)
  font-size: 62.5%;
  margin-bottom: 2rem;
}

#app {
  display: grid;
  grid-template-rows: 8rem minmax(calc(100vh - 8rem), 1fr);
  grid-template-columns: 1fr;

  // @media only screen and (min-width: $bp-large) {
  //   grid-template-rows: 8rem minmax(calc(100vh - 8rem), 1fr);
  //   grid-template-columns: 19rem 1fr; //max-content
  // }
}

#header__container{
  grid-row: 1/2;
  grid-column: 1/-1;
}

.page__header{
  text-align: center;
}

.main__component{
  margin-bottom: 5rem;
  // width: 100%;
}

.router-link-active{
  font-style: italic;
  // border-bottom: 1px solid red;
}

</style>
